import { EXCLUSIVE_TYPE } from '@interfaces/common.interface';
import { DEAL_TAG_ATTRIBUTES, DealStatus, DealType } from '@constants/deal.constants.tsx';
import { IDeal } from '@interfaces/deal';

export const roundPrice = (price: number) => {
	return price.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

export const generateDealTagText = (exclusiveType?: EXCLUSIVE_TYPE, text?: string, isDetail: boolean = false) => {
	if (isDetail || exclusiveType !== EXCLUSIVE_TYPE.NEW_USER) {
		return text;
	}
	return text?.split(' ')?.slice(0, -1).join(' ');
};

export const setDealTags = (deal: IDeal) => {
	if (!deal.dealType || deal.dealType.length === 0) {
		return deal;
	}

	if (deal.dealType === DealType.VOUCHER) {
		deal.tagAttribute = DEAL_TAG_ATTRIBUTES.VOUCHER;
	}

	switch (deal.status) {
		case DealStatus.COUNTDOWN:
			deal.tagAttribute = { ...deal.tagAttribute, ...DEAL_TAG_ATTRIBUTES.COUNTDOWN(deal?.startDate || '') };
			break;
		case DealStatus.ONGOING:
			deal.tagAttribute = { ...deal.tagAttribute, ...DEAL_TAG_ATTRIBUTES.ONGOING(deal?.endDate || '') };
			break;
		default:
			break;
	}

	if (deal.isFlash) {
		deal.tagAttribute = { ...deal.tagAttribute, ...DEAL_TAG_ATTRIBUTES.FLASH };
		if (deal.status === DealStatus.ONGOING) {
			deal.tagAttribute = {
				...DEAL_TAG_ATTRIBUTES.FLASH,
				...DEAL_TAG_ATTRIBUTES.ONGOING_FLASH({ qty: !!deal?.totalQuantity, date: deal?.endDate || '' }),
			};
		}
	}

	if (deal?.exclusiveType !== EXCLUSIVE_TYPE.NONE) {
		deal.tagAttribute = { ...DEAL_TAG_ATTRIBUTES.EXCLUSIVE(deal.exclusiveType || EXCLUSIVE_TYPE.NONE) };
	}

	if (deal?.status === DealStatus.ENDED) {
		deal.tagAttribute = DEAL_TAG_ATTRIBUTES.ENDED;
	}
	return deal;
};
